/* eslint-disable */
import * as Types from '../types.generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type GetCheckpointTrendsQueryVariables = Types.Exact<{
    input: Types.CheckpointTrendsInput;
}>;

export type GetCheckpointTrendsQuery = { __typename?: 'Query' } & {
    getCheckpointTrends: { __typename?: 'DataQualityTrendsResponse' } & {
        trend_data: Array<
            { __typename?: 'DataQualityTrendDataPoint' } & Pick<
                Types.DataQualityTrendDataPoint,
                'timestamp' | 'timestamp_str' | 'passed_count' | 'failed_count' | 'total_count'
            >
        >;
        metadata: { __typename?: 'DataQualityTrendsMetadata' } & Pick<
            Types.DataQualityTrendsMetadata,
            'from' | 'to' | 'interval' | 'total_passed' | 'total_failed' | 'overall_pass_rate'
        >;
    };
};

export const GetCheckpointTrendsDocument = gql`
    query GetCheckpointTrends($input: CheckpointTrendsInput!) {
        getCheckpointTrends(input: $input) {
            trend_data {
                timestamp
                timestamp_str
                passed_count
                failed_count
                total_count
            }
            metadata {
                from
                to
                interval
                total_passed
                total_failed
                overall_pass_rate
            }
        }
    }
`;

/**
 * __useGetCheckpointTrendsQuery__
 *
 * To run a query within a React component, call `useGetCheckpointTrendsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCheckpointTrendsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCheckpointTrendsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetCheckpointTrendsQuery(
    baseOptions: Apollo.QueryHookOptions<GetCheckpointTrendsQuery, GetCheckpointTrendsQueryVariables>,
) {
    return Apollo.useQuery<GetCheckpointTrendsQuery, GetCheckpointTrendsQueryVariables>(
        GetCheckpointTrendsDocument,
        baseOptions,
    );
}
export function useGetCheckpointTrendsLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<GetCheckpointTrendsQuery, GetCheckpointTrendsQueryVariables>,
) {
    return Apollo.useLazyQuery<GetCheckpointTrendsQuery, GetCheckpointTrendsQueryVariables>(
        GetCheckpointTrendsDocument,
        baseOptions,
    );
}
export type GetCheckpointTrendsQueryHookResult = ReturnType<typeof useGetCheckpointTrendsQuery>;
export type GetCheckpointTrendsLazyQueryHookResult = ReturnType<typeof useGetCheckpointTrendsLazyQuery>;
export type GetCheckpointTrendsQueryResult = Apollo.QueryResult<
    GetCheckpointTrendsQuery,
    GetCheckpointTrendsQueryVariables
>;
